// extracted by mini-css-extract-plugin
export default {"activation":"style_activation__lhASr"};